export const LOCAL_STORAGE = {
  TODOS_KEY: 'todos',
};
